export default function (height: number, options: {
  includeInches?: boolean,
} = {}) {
  const feet = Math.floor(height / 12);
  const inches = height % 12;

  if (options.includeInches === false && inches === 0) {
    return `${feet}'`;
  }

  return `${feet}'${inches}`;
}
